//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import {
  GetTikTokConnectionStatusResponse,
  GetTikTokOauthUrlResponse,
  OauthTikTokResponse,
  TikTokConnectionStatus,
} from '@bvengineering/tiktok-gateway-service-types';

import { IOAuthTikTokRequest } from '@apis/tiktok-settings/tiktokSettingsApiModel';
import { makeParams } from '@utils/makeParams';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const TIKTOK_DEFAULT_ENDPOINT = '/api/v1/oauth';

const tiktokGatewayOAuthFetch = (
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'tiktok_gateway',
    `${TIKTOK_DEFAULT_ENDPOINT}${endpoint}`,
    init,
  );
};

/**
 * Gets the TikTok token connection status
 *
 * GET /api/v1/oauth
 */
export const getConnectionStatus =
  async (): Promise<TikTokConnectionStatus> => {
    const res = await tiktokGatewayOAuthFetch(`/`);

    const json = await res.json<GetTikTokConnectionStatusResponse>();

    return json.data;
  };

/**
 * Gets url to oauth with TikTok
 *
 * GET /api/v1/oauth/url
 */
export const getOAuthUrl = async (): Promise<string> => {
  const res = await tiktokGatewayOAuthFetch(`/url`);

  const json = await res.json<GetTikTokOauthUrlResponse>();

  return json.data;
};

/**
 * Connect the client's TikTok using the provided authCode
 *
 * POST /api/v1/oauth/
 */
export const connect = async (
  request: IOAuthTikTokRequest,
): Promise<TikTokConnectionStatus> => {
  const queryParams = makeParams(request);
  const res = await tiktokGatewayOAuthFetch(`/?${queryParams}`, {
    method: 'POST',
  });

  const json = await res.json<OauthTikTokResponse>();

  return json.data;
};

/**
 * Revoke the client's TikTok token
 *
 * DELETE /api/v1/oauth/
 */
export const revokeToken = async (): Promise<void> => {
  await tiktokGatewayOAuthFetch(`/`, { method: 'DELETE' });
};
